import { VendingPackageVolumeHourDayHeatmapChart, hasChartSeries } from '@frontend/chart/components';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import { useInsightHeatmapCellClick } from '../heatmap-cell-summary/use-insight-heatmap-cell-click';
import { InsightCardWidth } from '../insight-card-width';
import { InsightCard } from '../insight-card/insight-card.component';
import { useInsightChartMinHeight } from '../insight-detail-mode.context';
import { InsightId } from '../insight-registry/insight-ids';
import { useLast2WeeksVendingPackageVolumeHourDayHeatmapChart } from './use-last-2-weeks-vending-package-volume-hour-day-heatmap-chart';

export interface Last2WeeksVendingPackageVolumeHourDayHeatmapChartProps {
    accountId: string;
    width?: InsightCardWidth;
}

export const Last2WeeksVendingPackageVolumeHourDayHeatmapChart = ({ accountId, width }: Last2WeeksVendingPackageVolumeHourDayHeatmapChartProps) => {
    const chartMinHeight = useInsightChartMinHeight(280);
    const { data, isLoading, rangeStart, dayCount } = useLast2WeeksVendingPackageVolumeHourDayHeatmapChart(accountId);
    const title = (
        <FormattedMessage
            id='platform.analytics.insights.vending-package-volume-hour-of-day-bar-chart.title'
            description='Title for the vending hour-of-day consumption peaks chart on analytics insights'
            defaultMessage='Peak consumption windows'
        />
    );
    const onCellClick = useInsightHeatmapCellClick({
        accountId,
        chartKey: VendingPackageVolumeHourDayHeatmapChart.definition.key,
        title
    });

    return (
        <InsightCard
            insightId={InsightId.VENDING_PEAK_CONSUMPTION_WINDOWS}
            chartKey={VendingPackageVolumeHourDayHeatmapChart.definition.key}
            width={width}
            title={title}
            subtitle={
                <FormattedMessage
                    id='platform.analytics.insights.last-2-weeks-vending-package-volume-hour-day-heatmap-chart.subtitle'
                    description='Subtitle on the vending hourly activity heatmap indicating the chart covers the last 14 days'
                    defaultMessage='last 14 days'
                />
            }
            isLoading={isLoading}>
            {!hasChartSeries(data) || !data ? (
                <div className='text-foreground-default'>{CommonMessage.ERRORS.NO_DATA_AVAILABLE}</div>
            ) : (
                <div
                    className='w-full min-w-0 overflow-hidden'
                    style={{ height: chartMinHeight }}>
                    <VendingPackageVolumeHourDayHeatmapChart
                        data={data}
                        rangeStart={rangeStart}
                        dayCount={dayCount}
                        minHeight={chartMinHeight}
                        onCellClick={onCellClick}
                    />
                </div>
            )}
        </InsightCard>
    );
};
